import React, { Component } from 'react';
import Inner from './Inner';
import './About.css';

class About extends Component {
    render() {
        return(
            <Inner title="About the artist">
	            <div className="about">
	            	<img src="/img/george.jpg" alt="George Otto"/>
	            	<p>I am predominantly a landscape painter, with a particular interest in marine subjects, but also like painting urban, figurative and wildlife subjects. I work from my home in Surrey and although most of my paintings are produced in the studio, I have a keen interest in painting outside, by direct observation of the subject matter that interests me at the time.</p>
	            	<p>I am inspired by light and colour in the subject matter and like to work in a variety of media. </p>
								<p>My work is mostly exhibited in Surrey. I am an elected member of Woking Society of Arts and Guildford Art Society. I am also currently Chairman of the Woking Society of Arts and serve on the Gallery Advisory Committee of The Lightbox in Woking.</p>
								<p>You can follow me on Twitter or Facebook using the links in the footer.</p>
	            </div>
            </Inner>
        )
    }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js